(function() {
  var ENDPOINT = 'https://jnvyktetzybejxqypece.supabase.co/functions/v1/dynamic-function';
  var emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  /* ===== Quote Product Line Items ===== */
  var PRODUCT_OPTIONS = [
    'Secret Stories Class Kit — Decorative Brights',
    'Secret Stories Class Kit — Cool Pastels',
    'Secret Stories Class Kit — Warm Neutrals',
    'Secret Stories Class Kit — Tropical Sunset',
    'Secret Stories Student Workbook',
    'Secret Stories Phonics Flashcards',
    'Secret Stories App (Subscription)',
    'Parent / Homeschool Bundle',
    'Other (describe in notes)'
  ];

  var PRODUCT_LABELS = [
    'Class Kit — Decorative Brights',
    'Class Kit — Cool Pastels',
    'Class Kit — Warm Neutrals',
    'Class Kit — Tropical Sunset',
    'Student Workbook',
    'Phonics Flashcards',
    'Secret Stories App (Subscription)',
    'Parent / Homeschool Bundle',
    'Other (describe in notes)'
  ];

  var productCount = 1;
  var addBtn = document.getElementById('quoteAddProduct');
  var productList = document.getElementById('quoteProductList');

  function createProductRow(n) {
    var row = document.createElement('div');
    row.className = 'cp-quote-products__row';

    var select = document.createElement('select');
    select.name = 'product_' + n;
    select.className = 'contact-page__select cp-quote-products__select';
    var defaultOpt = document.createElement('option');
    defaultOpt.value = '';
    defaultOpt.disabled = true;
    defaultOpt.selected = true;
    defaultOpt.textContent = 'Select a product…';
    select.appendChild(defaultOpt);

    for (var i = 0; i < PRODUCT_OPTIONS.length; i++) {
      var opt = document.createElement('option');
      opt.value = PRODUCT_OPTIONS[i];
      opt.textContent = PRODUCT_LABELS[i];
      select.appendChild(opt);
    }

    var qty = document.createElement('input');
    qty.type = 'number';
    qty.name = 'qty_' + n;
    qty.className = 'contact-page__input cp-quote-products__qty';
    qty.placeholder = 'Qty';
    qty.min = '1';
    qty.value = '1';

    var removeBtn = document.createElement('button');
    removeBtn.type = 'button';
    removeBtn.className = 'cp-quote-products__remove';
    removeBtn.setAttribute('aria-label', 'Remove');
    removeBtn.textContent = '×';
    removeBtn.addEventListener('click', function() { row.remove(); });

    row.appendChild(select);
    row.appendChild(qty);
    row.appendChild(removeBtn);
    return row;
  }

  if (addBtn && productList) {
    addBtn.addEventListener('click', function() {
      if (productCount >= 8) return;
      productCount++;
      productList.appendChild(createProductRow(productCount));
    });
  }

  /* ===== Modal Logic ===== */
  document.querySelectorAll('[data-modal]').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var id = 'cpModal-' + btn.getAttribute('data-modal');
      var modal = document.getElementById(id);
      if (modal) {
        modal.setAttribute('aria-hidden', 'false');
        document.body.style.overflow = 'hidden';
      }
    });
  });

  document.querySelectorAll('[data-modal-close]').forEach(function(el) {
    el.addEventListener('click', function() {
      var modal = el.closest('.cp-modal');
      if (modal) {
        modal.setAttribute('aria-hidden', 'true');
        document.body.style.overflow = '';
      }
    });
  });

  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') {
      document.querySelectorAll('.cp-modal[aria-hidden="false"]').forEach(function(m) {
        m.setAttribute('aria-hidden', 'true');
        document.body.style.overflow = '';
      });
    }
  });

  /* ===== Unified Form Handler ===== */
  document.querySelectorAll('.cp-form').forEach(function(form) {
    var submitBtn = form.querySelector('.contact-page__submit-btn');
    var errorEl   = form.querySelector('.cp-form__error');
    var successEl = form.querySelector('.cp-form__success');
    var btnText   = submitBtn ? submitBtn.textContent : 'Submit';
    var formType  = form.getAttribute('data-form-type') || 'General Inquiry';

    form.addEventListener('submit', function(e) {
      e.preventDefault();
      if (errorEl) { errorEl.textContent = ''; errorEl.classList.remove('is-visible'); }

      var data = {};
      var fields = form.querySelectorAll('input, select, textarea');
      var missing = false;

      fields.forEach(function(f) {
        if (!f.name) return;
        var val = f.value.trim();
        data[f.name] = val;
        if (f.required && !val) missing = true;
      });

      if (missing) {
        if (errorEl) { errorEl.textContent = 'Please fill in all required fields.'; errorEl.classList.add('is-visible'); }
        return;
      }

      if (data.email && !emailRegex.test(data.email)) {
        if (errorEl) { errorEl.textContent = 'Please enter a valid email address.'; errorEl.classList.add('is-visible'); }
        return;
      }

      var name = (data.first_name || '') + ' ' + (data.last_name || '');
      var subject = '[' + formType + ']';

      if (data.support_topic) subject += ' ' + data.support_topic;
      if (data.organization) subject += ' — ' + data.organization;

      var lines = [];
      lines.push('Form Type: ' + formType);
      lines.push('Name: ' + name.trim());
      if (data.email) lines.push('Email: ' + data.email);
      if (data.phone) lines.push('Phone: ' + data.phone);
      if (data.organization) lines.push('School/District: ' + data.organization);
      if (data.role) lines.push('Role: ' + data.role);

      /* Collect product line items */
      var productLines = [];
      for (var i = 1; i <= 8; i++) {
        var prod = data['product_' + i];
        var qty  = data['qty_' + i];
        if (prod) productLines.push('  • ' + prod + ' × ' + (qty || 1));
      }
      if (productLines.length) {
        lines.push('\nProducts Requested:');
        lines.push(productLines.join('\n'));
      }

      if (data.grade_levels) lines.push('Grade Levels: ' + data.grade_levels);
      if (data.vendor_pack) lines.push('W-9/Vendor Pack: ' + data.vendor_pack);
      if (data.support_topic) lines.push('Support Topic: ' + data.support_topic);
      if (data.order_number) lines.push('Order Number: ' + data.order_number);
      if (data.attendees) lines.push('Number of Attendees: ' + data.attendees);
      if (data.pd_format) lines.push('PD Format: ' + data.pd_format);
      if (data.preferred_dates) lines.push('Preferred Dates: ' + data.preferred_dates);
      if (data.subject) lines.push('Subject: ' + data.subject);
      if (data.message) lines.push('\nAdditional Notes:\n' + data.message);

      var payload = {
        name: name.trim(),
        email: data.email,
        phone: data.phone || '',
        subject: subject,
        message: lines.join('\n')
      };

      if (submitBtn) { submitBtn.disabled = true; submitBtn.textContent = 'Sending…'; }

      fetch(ENDPOINT, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      })
      .then(function(res) {
        if (!res.ok) throw new Error('Server returned ' + res.status);
        return res.json();
      })
      .then(function() {
        form.querySelectorAll('.contact-page__form-row, .contact-page__submit-btn, .cp-quote-products').forEach(function(el) {
          el.style.display = 'none';
        });
        if (successEl) successEl.classList.add('is-visible');
      })
      .catch(function() {
        if (errorEl) { errorEl.textContent = 'Something went wrong. Please try again or email support@thesecretstories.com.'; errorEl.classList.add('is-visible'); }
        if (submitBtn) { submitBtn.disabled = false; submitBtn.textContent = btnText; }
      });
    });
  });
})();
